import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

export default async function ToggleLikeLocation(locationId: string) {
  return fetch(`${baseUrl()}/api/v1/locations/${locationId}/like`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    }
  });
}
